<template>
  <div class="inner-banner__content inner-banner__subscription">
    <BaseSubHeading
      size="small"
      weight="400"
      color="monochrome-06"
    >
      {{ bannerTitle }}
    </BaseSubHeading>

    <button
      class="link is-small"
      type="button"
      @click="updateSubscription"
    >
      Upgrade Now
    </button>

    <BaseSubHeading
      size="small"
      weight="400"
      color="monochrome-06"
    >
      {{ bannerSubtitle }}
    </BaseSubHeading>

    <button
      v-if="!isSuperAdmin"
      class="inner-banner__close"
      type="button"
      @click="hideBanner"
    >
      <icon
        data="@icon/close2.svg"
        :fill="true"
        width="var(--icon-16)"
        height="var(--icon-16)"
      />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router"
import { useAcl } from "vue-simple-acl"
import { computed } from "vue"
import { useStore } from "vuex"

import { useModal } from "@/plugins/vue-js-modal/index"
import { Actions, Getters } from "@/store"
import { getTrialRemainingLabel } from "@/utils/dateUtil"

const props = defineProps({
  trialEndDate: {
    type: String,
    required: true
  }
})

const router = useRouter()
const modal = useModal()
const store = useStore()
const acl = useAcl()

const isAdmin = computed(() => acl.can.any(["admin", "superAdmin"]))
const isSuperAdmin = computed(() => acl.can("superAdmin"))

const remainingDays = computed(() => getTrialRemainingLabel(props.trialEndDate))

const bannerTitle = computed(() => {
  return acl.can("isBusiness")
    ? `Your AI Assistant Trial Ends in ${remainingDays.value}`
    : `${remainingDays.value} Left in the Free Trial`
})

const bannerSubtitle = computed(() => {
  return acl.can("isBusiness")
    ? "to keep AI Assistant and other Enterprise features!"
    : "to keep Business features that you enjoy!"
})

async function hideBanner() {
  const userSettings = store.getters[Getters.GET_USER_CURRENT_PROFILE_SETTINGS]

  await store.dispatch(Actions.UPDATE_PROFILE_SETTINGS, {
    settings: {
      ...userSettings,
      showEndTrialPeriod: false
    }
  })
}

function updateSubscription() {
  if (isAdmin.value) {
    router.push({
      name: "edit-account",
      query: {
        tab: "subscription"
      }
    })
    return
  }

  modal.show("upgrade-plan-without-permission")
}
</script>
